import { FC, useMemo } from 'react'
import { Form, Formik } from 'formik'
import { NavLink } from 'react-router-dom'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'

import style from '@src/pages/Login/Login.module.scss'
import { Button } from '@src/components/Button/Button'
import { phoneRegexp } from '@src/lib/regex'
import { validateForm } from '@src/messages/validateForm'
import { FieldFormik } from '@src/components/FieldFormik/FieldFormik'
import { login } from '@src/store/ducks/auth/thunks'
import { AppDispatch } from '@src/store/store'
import { selectBackError } from '@src/store/ducks/auth/selectors'

type LoginFormProps = {
  isLoading: boolean
}

export const LoginForm: FC<LoginFormProps> = ({ isLoading }) => {
  const dispatch = useDispatch<AppDispatch>()
  const backError = useSelector(selectBackError)

  const validationSchema = useMemo(() => (
    Yup.object().shape({
      loginUser: Yup.string().matches(phoneRegexp, validateForm.phone).required(validateForm.required),
      password: Yup.string().required(validateForm.required),
    })
  ), [])

  const initialValues = useMemo(() => ({
    loginUser: '',
    password: '',
  }), [])

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={({ loginUser, password }) => {
        dispatch(login(loginUser, password))
      }}
      validationSchema={validationSchema}
    >
      {() => (
        <Form>
          <div>
            <FieldFormik
              name="loginUser"
              placeholder="Номер телефона"
              mask="+{375} (00) 000-00-00"
            />
            <FieldFormik
              name="password"
              type="password"
              placeholder="Пароль"
            />
          </div>
          {backError && String(backError) && (
            <div className={style.error}>
              *
              {backError}
            </div>
          )}
          <div className={style.btnBlock}>
            <NavLink
              to="/lk/recovery-password"
              className={`${style.forgotBtn}`}
            >
              Забыли пароль?
            </NavLink>
            <Button
              loading={isLoading}
              htmlType="submit"
              type="secondary"
              className={style.btnSize}
            >
              Войти в личный кабинет
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  )
}
